import {
  TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA,
  TICKET_DASHBOARD_METRICS_TEAM_GET_DATA,
  TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA,
} from "./Constants";

const initialState = {
  loading: false,
  error: null,
  individualMetrics: {},
  teamMetrics: {},
  organizationMetrics: {},
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {

    // Individual
    case TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA.TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_LOAD:
      return { ...state, loading: true, individualMetrics: {}, error: null };
    case TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA.TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_SUCCESS:
      return { ...state, loading: false, individualMetrics: action.individualMetrics, error: null };
    case TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_DATA.TICKET_DASHBOARD_METRICS_INDIVIDUAL_GET_FAIL:
      return { ...state, loading: false, individualMetrics: {}, error: action.error };

    // Team
    case TICKET_DASHBOARD_METRICS_TEAM_GET_DATA.TICKET_DASHBOARD_METRICS_TEAM_GET_LOAD:
      return { ...state, loading: true, teamMetrics: {}, error: null };
    case TICKET_DASHBOARD_METRICS_TEAM_GET_DATA.TICKET_DASHBOARD_METRICS_TEAM_GET_SUCCESS:
      return { ...state, loading: false, teamMetrics: action.teamMetrics, error: null };
    case TICKET_DASHBOARD_METRICS_TEAM_GET_DATA.TICKET_DASHBOARD_METRICS_TEAM_GET_FAIL:
      return { ...state, loading: false, teamMetrics: {}, error: action.error };

    // Organization
    case TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA.TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_LOAD:
      return { ...state, loading: true, organizationMetrics: {}, error: null };
    case TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA.TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_SUCCESS:
      return { ...state, loading: false, organizationMetrics: action.organizationMetrics, error: null };
    case TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_DATA.TICKET_DASHBOARD_METRICS_ORGANIZATION_GET_FAIL:
      return { ...state, loading: false, organizationMetrics: {}, error: action.error };

    default:
      return { ...state };
  }
};

export default Reducer;